export default __webpack_public_path__ + "static/media/Mimosa Cocktail - proportioned_170.0b30f5d6.jpg";